import { render } from "./OrderCard.vue?vue&type=template&id=65c99a85&scoped=true"
import script from "./OrderCard.vue?vue&type=script&lang=js"
export * from "./OrderCard.vue?vue&type=script&lang=js"

import "./OrderCard.vue?vue&type=style&index=0&id=65c99a85&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c99a85"]])

export default __exports__